import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _DocumentFactory, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { YearSelector } from "../../../../../core/shared/inputs/YearSelector";
import { SelectorDocumentFactory } from "../../../../contabilidad/bodegaDocumentos/SelectorDocumentFactory";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { DocumentViewer } from "../../../../theme/Component/DocumentViewer";
import { ListMenu } from "../../../../theme/Component/ListMenu";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface Resp {
    Obs: string;
    Approve: string;
}

export const BPM003 = ({ configProcedure }: Props) => {

    const { lista, setLista, instance } = useDataBean(_DocumentFactory);
    const [documentos, setDocuementos] = useState<any>([]);
    const [doc, setDoc] = useState<any>({});

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });

    const [bean, setBean] = useState<any>({ Year: _single.getCurrenYear() });
    const [row, setRow] = useState<any>({});

    useEffect(() => {
        if (modal.view === false)
            setDocuementos([]);
    }, [modal.view])



    const buscarDocumento = () => {
        instance.getDocumentsAndConsecutive(bean.Year, bean.Mnemonic, bean.Consecutive ?? null, null, null, null, bean.Reference ?? null).then(
            (resp: any) => {
                setLista(resp);
                if (resp.length === 0) {
                    toast.warning("No se encontraron documentos");
                }
            }
        ).catch(err => toast.error(err));
    }

    const getPdfAccountantDocument = (data: any) => {
        setDoc(data);
        instance.getPdfAccountantDocument(data.IDDocument, data.Mnemonic, data.Since, _single.getAccountID()).then(
            (resp: any) => {
                setDocuementos(resp.DocumentURL);
                setModal({ ...modal, "view": true })
            }
        ).catch(err => toast.error(err));
    }

    const head = [
        { title: 'ID', property: 'IDDocument', visible: false },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Consecutivo Externo', property: 'ExternalReference', visible: true },
        { title: 'Fecha Creación', property: 'Since', visible: true },
        { title: 'Estado del Documento', property: 'DocumentStateName', visible: true },
    ]

    const validateData = () => {
        console.log(bean)
        if (bean.Year && bean.Mnemonic && (bean.Consecutive || bean.Reference)) {
            buscarDocumento();
        } else {
            toast.error("Los campos Año, Tipo y Consecutivo o Consecutivo Externo son Obligatorios");
        }
    }

    const listaBotonesItems = () => {
        const botones = [
            { titulo: 'Ver Documento', icono: 'ri-edit-2-line', visible: true, evento: () => { getPdfAccountantDocument(row) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const saveSupplier = () => {
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(`Se asigna el documento ${row.Mnemonic} - ${row.Consecutive} a la solicitud`)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(row)
        }

        if (configProcedure?._pushProps) {
            configProcedure?._pushProps(row)
        }

        console.log(row)
    }


    return (
        <>
            <div className="row">
                <div className="col-md-6">
                    <YearSelector value={bean.Year} onChange={(e) => { setBean({ ...bean, "Year": e }) }} />
                </div>
                <div className="col-md-6">
                    <SelectorDocumentFactory label="Tipo de Documento" onChange={(e) => { setBean({ ...bean, "Mnemonic": e.Mnemonic }) }} />
                </div>
                <div className="col-md-6">
                    <label>Consecutivo</label>
                    <input type="number" name="consecutivo" className="form-control" value={bean.Consecutive} onChange={(e) => { setBean({ ...bean, "Consecutive": parseInt(e.target.value) }) }} />
                </div>
                <div className="col-md-6">
                    <label>Consecutivo Externo</label>
                    <input type="number" name="consecutivoExt" className="form-control" value={bean.Reference} onChange={(e) => { setBean({ ...bean, "Reference": parseInt(e.target.value) }) }} />
                </div>
                <div className="col-md-6 mt-4">
                    <BasicButton icon="ri-search-line" eventClick={validateData}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable listButtons={listaBotonesItems()} body={lista} head={head} rowSet={setRow} />
                </div>

                <div className="col-md-6 mt-4">
                    <BasicButton disable={row.IDDocument ? false : true} children={"Guardar"} eventClick={() => {
                        if (row.IDDocument) {
                            saveSupplier()
                        } else {
                            toast.error("La observacion debe tener un minimo de 15 caracteres")
                        }
                    }} icon="ri-save-line" />
                </div>
            </div>

            <Modal modal={modal} updateModal={setModal}>
                <div className="row">
                    <div className="col">
                        <DocumentViewer list={documentos} IDDocument={doc.IDDocument} Since={doc.Since} />
                    </div>
                </div>
            </Modal>
        </>
    );
}